import { Observable } from 'rxjs';

export function deferAsyncIterable<T>(
  handler: (signal: AbortSignal) => Promise<AsyncIterable<T>>,
): Observable<T> {
  return new Observable<T>((observer) => {
    const controller = new AbortController();
    const signal = controller.signal;

    observer.add(() => {
      controller.abort();
    });

    handler(signal)
      .then(async (iterable) => {
        for await (const item of iterable) {
          // TODO does it make sense. Need to reconsider this approach farther
          if (signal.aborted) {
            break;
          }
          observer.next(item);
        }

        if (!observer.closed) {
          observer.complete();
        }
      })
      .catch((err) => {
        observer.error(err);
      });
  });
}
